<app-header headerText="Reporte de Movimientos"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true >
  <!-- pestaña reportes por rango de fechas-->
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>assignment_ind</mat-icon>
      Filtrados<br>&nbsp;
    </ng-template>
    <div class="mt-5 row">

      <div class="col-md-4">
        <mat-form-field>
          <input matInput [matDatepicker]="inicioDeCalculoPicker" placeholder="Fecha Inicio de Reporte:"
            (dateChange)="setStartDate($event)" [value]="reportDate.startDate">
          <mat-datepicker-toggle matSuffix [for]="inicioDeCalculoPicker"></mat-datepicker-toggle>
          <mat-datepicker #inicioDeCalculoPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field>
          <input matInput [matDatepicker]="exceptionPicker" placeholder="Fecha Fin de Reporte:"
            (dateChange)="setEndDate($event)" [value]="reportDate.endDate">
          <mat-datepicker-toggle matSuffix [for]="exceptionPicker"></mat-datepicker-toggle>
          <mat-datepicker #exceptionPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <mat-form-field appearance="legacy">
          <mat-label>Número colaborador</mat-label>
          <input matInput placeholder="Placeholder" [(ngModel)]="employeeNumber">
        </mat-form-field>
      </div>
    </div><br>

    <div class="row" *ngIf="savingParameters">
        <div class="col-md-4 center-vertically" *ngFor="let period of savingParameters" >
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
            (click)="collectionReportLoansList(period.parametersID, period.title ,true)">Lista de Espera Ahorradores {{period.title}}</button>
        </div>
        <div class="col-md-4 center-vertically"  *ngFor="let period of savingParameters" >
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
            (click)="collectionReportLoansList(period.parametersID, period.title ,false)">Lista de Espera No Ahorradores {{period.title}}</button>
        </div>
    </div>
    <div class="row">
      <!--div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="BillingReport()">Reporte
          Facturación</button>
      </div-->

      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportData('CAL', ['CAL_AL','CAL_C','CAL_CE','CAL_CL','CAL_N','CAL_NE','CAL_RL','CAL_R', 'CAL_RE'] )">Reporte
          CAL</button>
      </div>
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReporDR('CAL')">Reporte
          CAL_DR</button>
      </div>
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportData('CAR', ['CAR_DR', 'CAR_DRE'])">Reporte
          CAR_DR</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportData('CAR')">Reporte
          CAR</button>
      </div>
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportData('FAC')">Reporte
          FAC</button>
      </div>
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportData('FAL')">Reporte
          FAL</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportSura('FAL_SURA')">Reporte
          FAL_SURA</button>
      </div>
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportSura('FAC_SURA')">Reporte
          FAC_SURA</button>
      </div>
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportSura('CAL_SURA')">Reporte
          CAL_SURA</button>
      </div>
  </div>
  <div class="row">
    <div class="col-md-4 center-vertically">
      <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
        (click)="collectionReportSura('CAR_SURA')">Reporte
        CAR_SURA</button>
    </div>
</div>

  </mat-tab>


  <!-- pestaña reportes por  compañia-->
  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>business</mat-icon>
      Generales<br>&nbsp;
    </ng-template>

    <div>

      <div class="row">
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary" (click)="employeeReport()">Reporte
            Colaboradores</button>
        </div>
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary" (click)="liquidityReport()">Reporte
            Liquidez</button>
        </div>
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary" (click)="liquidityReport()">
            Caja de Ahorro</button>
        </div>
      </div>
          <div class="row" *ngIf="savingParameters">
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="collectionReportAportExt()">Reporte Aportaciónes Ext.</button>
      </div>
      <div class="col-md-4 center-vertically">
        <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
          (click)="reportSavingShares()">Reporte Ahorro Acciones</button>
      </div>
    </div>
      <hr style="margin: 0px; padding: 0px;">
      <div class="row mt-4">
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
            (click)="buildLoanData('LOANTRANSACTIONS')">Reporte Préstamos</button>
        </div>
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary" 
          (click)="buildLoanData('CAL')">Reporte
            CAL</button>
        </div>
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
            (click)="buildLoanData('CAR')">Reporte
            CAR</button>
        </div>

      </div>
      <div class="row">
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
            (click)="buildLoanData('FAC')">Reporte
            FAC</button>
        </div>
        <div class="col-md-4 center-vertically">
          <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
            (click)="buildLoanData('FAL')">Reporte
            FAL</button>
        </div>
      </div>
    </div>
  </mat-tab>

</mat-tab-group>
